<template>
	<div id="app">
		<el-container>
			<el-header>
				<div class="logo">
					<img src="./assets/img/topLOGO (2).png" alt />
				</div>
				<el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect" :router="router"
				 text-color="#231815" active-text-color="#147DD0">
					<el-menu-item index="/" class="clearfix"><i class="el-icon-s-home"></i><span>首页</span></el-menu-item>
					<el-menu-item index="/aboutus">关于我们</el-menu-item>
					<el-menu-item index="/News">新闻中心</el-menu-item>
					<el-menu-item index="/logistics">在线服务</el-menu-item>
					<el-menu-item index="/product">客户服务</el-menu-item>
					<!-- <el-menu-item index="/Case">成功案例</el-menu-item> -->
					<!-- <el-menu-item index="/download">联系我们</el-menu-item> -->
					<el-menu-item index="/zhaopin">人才招聘</el-menu-item>
					<!-- <el-menu-item @click="links" class="clearfix"><img src="@/assets/home/aic.jpg" width="30px" alt=""><span>海外物流</span></el-menu-item> -->
					<!-- <el-menu-item @click="links1" class="clearfix"><span>DBS</span></el-menu-item> -->
				</el-menu>
			</el-header>
			<el-main>
				<router-view />
			</el-main>
			<div class="footer" v-show="isShow">
				<!-- <div class="dibu clearfix">
					<p>www.js-chinaarts.com</p>
					<p>@2020 版权所有 中艺储运江苏有限责任公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#d8d8d8"> 苏ICP备12051038号</a></p>
				</div> -->
				<div class="footer-content clearfix">
					<div class="left">
						<img src="./assets/home/dibulogo.png" alt="" max-width='140px' height="auto" />
						<el-menu :default-active="defaultActive" background-color="transparent" class="el-menu-demo" mode="horizontal"
						 @select="handleSelect" :router="router" text-color="#F8F8F8" active-text-color="#F8F8F8">
							<el-menu-item index="/"><span>首页</span></el-menu-item>
							<div class="fenge">/</div>
							<el-menu-item index="/aboutus">关于我们</el-menu-item>
							<div class="fenge">/</div>
							<el-menu-item index="/News">新闻中心</el-menu-item>
							<div class="fenge">/</div>
							<el-menu-item index="/logistics">在线服务</el-menu-item>
							<div class="fenge">/</div>
							<el-menu-item index="/product">客户服务</el-menu-item>
						
							<div class="fenge">/</div>
							<!-- <el-menu-item index="/download">联系我们</el-menu-item>
							<div class="fenge">/</div> -->
							<el-menu-item index="/zhaopin">人才招聘</el-menu-item>
							<el-menu-item index="/publicPage"></el-menu-item>
						</el-menu>
					</div>
					<div class="right clearfix">
						<div class="yi">CONTACT</div>
						<p>地址：{{address}}</p>
						<div class="er">TEL : {{tel}}</div>
						<div class="san">E-mail : {{email}}</div>
					</div>
				</div>
				<div class="dibu clearfix">
					<p>www.js-chinaarts.com</p>
					<p>@2020 版权所有 中艺储运江苏有限责任公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#d8d8d8"> 苏ICP备12051038号</a></p>
				</div>
			</div>
		</el-container>
		<Login :dialogVisibles="istrue" @closepop="closepops" />
		<platform :dialogVisibles="istrue1" @closepop="closepops1" />
		<div class="footer">
			<div class="gotop" v-show="gotop" @click="toTop"></div>
		</div>
	</div>
</template>

<script>
	import Login from "@/views/logi.vue";
	import platform from "@/views/platform.vue";

	export default {
		components: {
			Login,
			platform
		},
		data() {
			return {
				gotop: false,
				istrue: false,
				istrue1: false,
				router: true,
				defaultActive: "/aboutus",
				isShow: true,
				address:'',
				tel:'',
				fax:'',
				Website:'',
				email:''
			};
		},
		methods: {
			links() {
				window.open('http://cat.js-chinaarts.com/index.html#/login');
			},
			links1() {
				window.open('http://njsg.f3322.org:28081/jeesns/');
			},
			closepops() {
				this.istrue = false;
			},
			closepops1() {
				this.istrue1 = false;
			},
			logins() {
				this.istrue = true;
			},
			platforms() {
				this.istrue1 = true;
			},
			handleSelect(key) {},
			handleScroll() {
				let scrolltop =
					document.documentElement.scrollTop || document.body.scrollTop;
				scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
			},
			toTop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop;
				// 实现滚动效果
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
					if (top <= 0) {
						clearInterval(timeTop);
					}
				}, 10);
			},
			//获取联系方式
			getData(){
				var that = this;
				that.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						that.address = data.address;
						that.tel = data.company_phone;
						that.fax = data.fax;
						that.email = data.email;
						that.Website=res.data.detail.email.split('/')[1]
					}
				
				})
			}
		},
		mounted() {
			// 此处true需要加上，不加滚动事件可能绑定不成功
			window.addEventListener("scroll", this.handleScroll, true);
			console.log(this.$route);
			this.getData();
		},
	};
</script>
<style lang='scss'>
    .homeheader{
        .el-menu-item{
            padding: 0 10px !important
        }
    }
</style>
<style lang="scss" scoped="scoped">
	::v-deep.el-menu-item {
		padding: 0 20px;
	}

	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		height: 100%;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	.el-header {
		display: flex;
		justify-content: center;
		align-content: center;
		width: 100%;
		margin: 0 auto;
		//background-color: #fff;
		.logo { 
			width: 339px;
			padding-top: 12px;
			img {
				display: block;
				width: 100%;
			}
		}
	}

	.el-main {
		padding: 0 !important;
		overflow: hidden;
	}

	.footer {
		min-width: 100%;
		height: auto;

		overflow: hidden;
		background-color: #25315b;

		&-content {
			width: 62.5%;
			margin: 0 auto;
			padding: 50px 0 16px;
			overflow: hidden;

			.left {
				float: left;

				img {
					display: block;
					width: 340px;
					height: 51px;
					margin: 7px 0 43px 6px;
				}
			}

			.right {
				float: right;
				width: 270px;
				color: #d8d8d8;

				.yi {
					float: left;
					width: 100%;
					font-size: 24px;
					font-weight: 700;
				}

				p {
					float: left;
					width: 100%;
					font-size: 14px;
					margin: 5px 0;
				}

				.er,
				.san {
					float: left;
					padding-right: 5px;
					font-size: 17px;
					height: 34px;
					line-height: 34px;
					font-weight: 400;
					border-bottom: 2px solid #414b6e;
				}
			}
		}

		.dibu {
			border-top: 2px solid #a2a6b2;
			margin-bottom: 16px;
			width: 62.5%;
			margin: auto;

			p {
				font-size: 14px;
				color: #d8d8d8;
				height: 68px;
				line-height: 68px;
			}

			p:first-child {
				float: left;
			}

			p:last-child {
				float: right;
			}
		}
	}

	.toubu {
		background-color: #ececec;
	}

	.toubu>div {
		width: 100%;
		margin: auto;
	}

	.toubu>div>p {
		padding-left: 20px;
		float: left;
		height: 31px;
		line-height: 31px;
		font-size: 14px;
		color: #575757;
	}

	.toubu .login {
		float: right;
		margin-right: 60px;
	}

	.toubu .login .name,
	.toubu .login .denglu,
	.toubu .login .xuanze {
		float: right;
		height: 15px;

		line-height: 15px;
		color: #353535;
		font-size: 14px;
		margin: 6px 0 0 20px;
	}

	.toubu .login .name,
	.toubu .login .denglu {
		padding-left: 20px;
		background-image: url(assets/home/ren.png);
		background-size: contain;
		background-repeat: no-repeat;
		background-position: left top;
	}

	.toubu .login .xuanze {
		padding-right: 20px;
		background-image: url(assets/home/xiala.png);
		background-size: contain;
		background-repeat: no-repeat;
		background-position: right top;
	}

	.footer .gotop {
		text-align: center;
		position: fixed;
		right: 50px;
		bottom: 30px;
		cursor: pointer;
		border-radius: 50%;
		height: 100px;
		width: 100px;
		background-image: url("../src/assets/img/toTop.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: 100% 100%;
	}
</style>
